import styled from 'styled-components';
import { media } from './utils';

const CardGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  width: 100%;

  > * {
    margin: 0 0 1rem;
  }

  ${media.tabletNarrow`
    justify-content: space-between;
    max-width: calc(640px + 2rem);
  `}
  ${media.tabletWide`
    justify-content: space-between;
    max-width: calc(960px + 5rem);
  `}
`;

export default CardGroup;


// WEBPACK FOOTER //
// ./src/modules/common/components/ui/CardGroup.js